import { addBreadcrumb, captureException } from '@sentry/browser'
import { modifyMutable, produce } from 'solid-js/store'
import { flatten, isValiError, parse } from 'valibot'
import { setAlertBagError } from '../../../../rx/store/AlertBag'
import { deepClone } from '../../../deep_clone'
import { getEngineAlertBag } from '../../../three/fn/getSetEngineAlertBag'
import { getEngineToast } from '../../../three/fn/getSetEngineToast'
import { Engine } from '../../engine/Engine.type'
import { StateSchema } from '../State.type'
import Action from './action/Action.type'
import type ActionHandler from './ActionHandler.type'
import actionHandlersList, { type ActionSchemaUnion } from './actionHandlersList.generated'
import type { ActionLog } from './ActionLog.type'

// let lastClientDispatch: Promise<unknown> | null = null
export default async function dispatchFromRemote(engine: Engine, action: Action, expectedActionLog : ActionLog): Promise<void> {
  // console.log('dispatchFromRemote', action)
  addBreadcrumb({
    category: 'action',
    level: 'info',
    data: {
      action,
    },
  })
  try {
    // const handler = actionHandlersList.get(action.type)
    const tuple = actionHandlersList.find((t) => action.type === t[0])
    if (tuple) {
      // const actionType = tuple[0]
      const actionSchema: ActionSchemaUnion = tuple[1]
      const actionHandler: ActionHandler = tuple[2]
      const validatedAction = parse(actionSchema, action)
      // await actionHandler(engine, validatedAction)

      const actionLog : ActionLog = {
        cref: expectedActionLog.cref,
        round: engine.state.round,
        player_id: expectedActionLog.player_id,// TODO
        at: expectedActionLog.at,
        action: validatedAction,
      }

      // the lack of await on modifyMutable
      // probably makes this broken
      // no
      // if (shouldOptimisticUpdate) {
      modifyMutable(
        engine,
        produce(async (engine) => {
          await actionHandler(engine, validatedAction, actionLog)
        })
      )
      // }
      // throw an exception if an action fails the schema
      parse(StateSchema, engine.state)
      modifyMutable(
        engine,
        produce((engine) => {
          engine.prevState = deepClone(engine.state)
        })
      )
    } else {
      throw new Error(`Action ${action.type} is not supported`)
    }
  } catch (err) {
    const toast = getEngineToast(engine)
    const ab = getEngineAlertBag(engine)
    const msg: string = (err as { message?: string }).message || 'unknown'
    const context: Record<string, unknown> = {}
    if (isValiError(err)) {
      context.errors = flatten(err.issues)
    }
    const err2 = new Error(`Action Failed: ${msg}`, { cause: err })
    console.error(err, context)
    captureException(err, context)
    if (toast) {
      toast.error(msg)
    }
    if (ab) {
      setAlertBagError(ab, err2)
    }
  }
}
